import {Component, Inject, OnInit} from '@angular/core';
import {AssistanceService} from '../../../../../domain/assistance/service/assistance.service';
import {AmplitudeService} from '../../../../../application/analytics/service/amplitude.service';
import {AnalyticsEventType} from '../../../../../application/analytics/analytics-event-type';
import {AnalyticsCategory} from '../../../../../application/analytics/analytics-category';
import {App} from '../../../../../domain/core/model/app';
import {UserContextService} from '../../../../../application/app-context/user-context/user-context.service';
import {AppLauncherApplication, ApplicationState} from '../../../../../domain/app-launcher/model/app-launcher';
import {AppAssistanceRequestType} from '../../../../../domain/core/model/app-assistance-request-type';
import {UserContext} from '../../../../../application/app-context/user-context/user-context';
import {SalutationPipe} from '../../../../pipes/salutation.pipe';
import {Account} from '../../../../../domain/core/model/account';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ApplicationNamePipe} from '../../../../pipes/application-name.pipe';
import {Portfolio} from '../../../../../domain/portfolio/model/portfolio';
import {Solutions} from '../../../../../domain/core/model/solutions';
import {PortfolioSolutionsEnum} from '../../../../../domain/core/model/portfolio-solutions.enum';

@Component({
             templateUrl: './home-assistance-create-request-dialog.component.html',
             styleUrls: ['./home-assistance-create-request-dialog.component.scss']
           })
export class HomeAssistanceCreateRequestDialogComponent implements OnInit {

  private static readonly SOLUTIONS_ENABLED_FOR_ASSISTANCES = [
    Solutions.insito,
    Solutions.insito_sante,
    Solutions.insito_habitat,
    Solutions.apollo,
    Solutions.inviseo,
    Solutions.alliance,
    Solutions.dotations
  ];

  PortfolioSolutionsValues: Array<string> = Object.values(PortfolioSolutionsEnum);

  ASSISTANCE_REQUEST_TYPES = AppAssistanceRequestType;
  salutationPipe = new SalutationPipe();

  userContext: UserContext | undefined;
  portfolios: Array<Portfolio> | undefined;
  requestType = AppAssistanceRequestType.CONSULTANT;
  userApplications: Array<AppLauncherApplication> | undefined;
  selectedUserApplicationForRequest: AppLauncherApplication | undefined;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private userContextService: UserContextService,
              private assistanceService: AssistanceService,
              private amplitudeService: AmplitudeService,
              private translateService: TranslateService,
              private applicationNamePipe: ApplicationNamePipe) {
  }


  ngOnInit(): void {
    this.assistanceService.getAccountPortfolio()
        .subscribe(portfolios => this.portfolios = portfolios);

    this.userContext = this.userContextService.getUserContext();
    this.userApplications = this.userContext
                                .user
                                .appLauncher?.applications
                                .filter(application => ApplicationState.IS_ENABLED === application.state)
                                .filter(application => this.isApplicationEnabledForAssistance(application));

    if (this.userApplications?.length) {
      this.selectedUserApplicationForRequest = this.data.solution
                                               ? this.userApplications.find(app => this.data.solution.includes(app.appId))
                                               : this.userApplications[0];
    }
  }

  onChangeFromApplication(application: AppLauncherApplication): void {
    this.selectedUserApplicationForRequest = application;
  }

  onSendRequest(): void {
    if (!this.selectedUserApplicationForRequest || !this.requestType) {
      return;
    }

    const eventProperties = new Map<string, string>();
    eventProperties.set('Origine', this.data?.origin);
    eventProperties.set('Plateforme', this.applicationNamePipe.transform(this.selectedUserApplicationForRequest.name));
    eventProperties.set('TypeDeDemande',
                        this.translateService.instant(this.requestType === AppAssistanceRequestType.CONSULTANT
                                                      ? 'assistance.assistance'
                                                      : 'update'));
    this.amplitudeService.trackEventAction(AnalyticsCategory.assistance, AnalyticsEventType.contact, eventProperties);

    window.open(this.getMailToForUserWithAssistance(), '_blank');
  }

  private getMailToForUserWithAssistance(): string {
    const isPremium = this.portfolios.filter(p => p.premium).length > 0;
    return `mailto:${App.getAssistanceRequestMailAddress(this.selectedUserApplicationForRequest,
                                                         this.requestType,
                                                         isPremium,
                                                         this.hasHabitatAccess())}?`
           + `subject=[${new Date().toLocaleDateString()}][idClient=${this.userContext?.accountId}][idPlateforme=${this.getIdPlateforme(this.selectedUserApplicationForRequest.appId)}]`
           + `[${this.getCurrentAccount()?.name}]`
           + `[${this.salutationPipe.transform(this.userContext?.user.salutation)} ${this.userContext?.user.firstname} ${this.userContext?.user.lastname}] ${this.requestType}`;
  }

  private getIdPlateforme(appId: string): string | undefined {
    return [App.INSITO.key, App.SANTE.key, App.HABITAT.key].indexOf(appId) > -1 ? 'INSITO_J2EE' : appId.toUpperCase();
  }

  private getCurrentAccount(): Account | undefined {
    return this.userContext?.user.accounts.find(account => account.accountId === this.userContext?.accountId);
  }

  private isApplicationEnabledForAssistance(application: AppLauncherApplication) {
    return HomeAssistanceCreateRequestDialogComponent.SOLUTIONS_ENABLED_FOR_ASSISTANCES.includes(application.appId.toLowerCase());
  }

  private hasHabitatAccess(): boolean {
    return this.selectedUserApplicationForRequest?.appId === App.INSITO.key
           && (this.userContext?.getCurrentAccount()
                   ?.applications
                   ?.some(app => app.applicationName === App.HABITAT.label && app.hasAccess)
               ?? false);
  }
}
